import { apiFetch } from './client';

export interface PartnerKey {
  id: string;
  partnerId: string;
  role: 'partner_public' | 'honeywell_pair';
  keyType: 'pgp' | 'ssh';
  armoredPublic: string;
  fingerprint: string;
  algorithm: string | null;
  keySize: number | null;
  vaultSecretPath: string | null;
  isActive: boolean;
  createdAt: string;
  expiresAt: string | null;
  revokedAt: string | null;
}

export interface PartnerKeyListResponse {
  keys: PartnerKey[];
}

export interface ImportPartnerKeyPayload {
  role: 'partner_public' | 'honeywell_pair';
  keyType?: 'pgp' | 'ssh';
  armoredPublic: string;
  vaultSecretPath?: string;
}

export interface SweepExpiringKeysResult {
  checked: number;
  notified: number;
  keys: PartnerKey[];
}

export const partnerKeysApi = {
  list: (partnerId: string): Promise<PartnerKeyListResponse> => {
    return apiFetch<PartnerKeyListResponse>(`/partners/${partnerId}/keys`);
  },

  import: (partnerId: string, data: ImportPartnerKeyPayload): Promise<PartnerKey> => {
    return apiFetch<PartnerKey>(`/partners/${partnerId}/keys`, { method: 'POST', data });
  },

  generateHoneywell: (
    partnerId: string,
    data: { rsaBits?: number } = {},
  ): Promise<PartnerKey> => {
    return apiFetch<PartnerKey>(`/partners/${partnerId}/keys/generate-honeywell`, {
      method: 'POST',
      data,
    });
  },

  revoke: (partnerId: string, keyId: string): Promise<{ message: string }> => {
    return apiFetch<{ message: string }>(`/partners/${partnerId}/keys/${keyId}`, {
      method: 'DELETE',
    });
  },

  honeywellPublicKey: (partnerId: string): Promise<PartnerKey> => {
    return apiFetch<PartnerKey>(`/partners/${partnerId}/keys/honeywell-public`);
  },

  // Cross-partner "expiring soon" view (Keyring landing tab) and the manual
  // trigger for the same sweep onering-crons' pgp-key-expiry.yml runs daily.
  expiring: (days = 30): Promise<PartnerKeyListResponse> => {
    return apiFetch<PartnerKeyListResponse>(`/partner-keys/expiring?days=${days}`);
  },

  sweepExpiring: (days = 30): Promise<SweepExpiringKeysResult> => {
    return apiFetch<SweepExpiringKeysResult>('/partner-keys/sweep-expiring', {
      method: 'POST',
      data: { days },
    });
  },
};
